import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "chat-line chat-line-prompt-list"
};
const _hoisted_2 = {
  class: "chat-line-inner"
};
const _hoisted_3 = {
  class: "chat-icon"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "chat-item"
};
const _hoisted_6 = {
  key: 0,
  class: "file-list-box"
};
const _hoisted_7 = {
  key: 0,
  class: "image"
};
const _hoisted_8 = {
  key: 1,
  class: "item"
};
const _hoisted_9 = {
  class: "icon"
};
const _hoisted_10 = {
  class: "body"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 1,
  class: "bar"
};
const _hoisted_15 = {
  class: "bar-item"
};
const _hoisted_16 = {
  class: "bar-item"
};
const _hoisted_17 = {
  key: 1,
  class: "chat-line chat-line-prompt-chat"
};
const _hoisted_18 = {
  class: "chat-line-inner"
};
const _hoisted_19 = {
  class: "chat-icon"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "chat-item"
};
const _hoisted_22 = {
  key: 0,
  class: "file-list-box"
};
const _hoisted_23 = {
  key: 0,
  class: "image"
};
const _hoisted_24 = {
  key: 1,
  class: "item"
};
const _hoisted_25 = {
  class: "icon"
};
const _hoisted_26 = {
  class: "body"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "info"
};
const _hoisted_29 = {
  class: "content-wrapper"
};
const _hoisted_30 = ["innerHTML"];
const _hoisted_31 = {
  key: 1,
  class: "bar"
};
const _hoisted_32 = {
  class: "bar-item"
};
import { onMounted, ref } from "vue";
import { Clock } from "@element-plus/icons-vue";
import { httpPost } from "@/utils/http";
import hl from "highlight.js";
import { dateFormat, isImage, processPrompt } from "@/utils/libs";
import { FormatFileSize, GetFileIcon, GetFileType } from "@/store/system";
import emoji from "markdown-it-emoji";
import mathjaxPlugin from "markdown-it-mathjax3";
import MarkdownIt from "markdown-it";
export default {
  __name: 'ChatPrompt',
  props: {
    data: {
      type: Object,
      default: {
        content: "",
        created_at: "",
        tokens: 0,
        model: "",
        icon: ""
      }
    },
    listStyle: {
      type: String,
      default: "list"
    }
  },
  setup(__props) {
    const md = new MarkdownIt({
      breaks: true,
      html: true,
      linkify: true,
      typographer: true,
      highlight: function (str, lang) {
        const codeIndex = parseInt(Date.now()) + Math.floor(Math.random() * 10000000);
        // 显示复制代码按钮
        const copyBtn = `<span class="copy-code-btn" data-clipboard-action="copy" data-clipboard-target="#copy-target-${codeIndex}">复制</span>
<textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy-target-${codeIndex}">${str.replace(/<\/textarea>/g, "&lt;/textarea>")}</textarea>`;
        if (lang && hl.getLanguage(lang)) {
          const langHtml = `<span class="lang-name">${lang}</span>`;
          // 处理代码高亮
          const preCode = hl.highlight(lang, str, true).value;
          // 将代码包裹在 pre 中
          return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code>${copyBtn} ${langHtml}</pre>`;
        }

        // 处理代码高亮
        const preCode = md.utils.escapeHtml(str);
        // 将代码包裹在 pre 中
        return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code>${copyBtn}</pre>`;
      }
    });
    md.use(mathjaxPlugin);
    md.use(emoji);
    const props = __props;
    const finalTokens = ref(props.data.tokens);
    const content = ref(processPrompt(props.data.content));
    const files = ref([]);
    onMounted(() => {
      processFiles();
    });
    const processFiles = () => {
      if (!props.data.content) {
        return;
      }
      const linkRegex = /(https?:\/\/\S+)/g;
      const links = props.data.content.match(linkRegex);
      const urlPrefix = `${window.location.protocol}//${window.location.host}`;
      if (links) {
        const _links = links.map(link => {
          if (link.startsWith(urlPrefix)) {
            return link.replace(urlPrefix, "");
          }
          return link;
        });
        // 合并数组并去重
        const urls = [...new Set([...links, ..._links])];
        httpPost("/upload/list", {
          urls: urls
        }).then(res => {
          files.value = res.data.items;
          for (let link of links) {
            if (isExternalImg(link, files.value)) {
              files.value.push({
                url: link,
                ext: ".png"
              });
            }
          }
        }).catch(() => {});
        for (let link of links) {
          content.value = content.value.replace(link, "");
        }
      }
      content.value = md.render(content.value.trim());
    };
    const isExternalImg = (link, files) => {
      return isImage(link) && !files.find(file => file.url === link);
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_icon = _resolveComponent("el-icon");
      return __props.listStyle === 'list' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: __props.data.icon,
        alt: "User"
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [files.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, file => {
        return _openBlock(), _createElementBlock("div", null, [_unref(isImage)(file.ext) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_image, {
          src: file.url,
          fit: "cover"
        }, null, 8, ["src"])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_image, {
          src: _unref(GetFileIcon)(file.ext),
          fit: "cover"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_link, {
          href: file.url,
          target: "_blank",
          style: {
            "--el-font-weight-primary": "bold"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(file.name), 1)]),
          _: 2
        }, 1032, ["href"])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(_unref(GetFileType)(file.ext)), 1), _createElementVNode("span", null, _toDisplayString(_unref(FormatFileSize)(file.size)), 1)])])]))]);
      }), 256))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "content",
        innerHTML: content.value
      }, null, 8, _hoisted_13), __props.data.created_at > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Clock))]),
        _: 1
      }), _createTextVNode(" " + _toDisplayString(_unref(dateFormat)(__props.data.created_at)), 1)]), _createElementVNode("span", _hoisted_16, "tokens: " + _toDisplayString(finalTokens.value), 1)])) : _createCommentVNode("", true)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
        src: __props.data.icon,
        alt: "User"
      }, null, 8, _hoisted_20)]), _createElementVNode("div", _hoisted_21, [files.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, file => {
        return _openBlock(), _createElementBlock("div", null, [_unref(isImage)(file.ext) ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_image, {
          src: file.url,
          fit: "cover"
        }, null, 8, ["src"])])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_image, {
          src: _unref(GetFileIcon)(file.ext),
          fit: "cover"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_link, {
          href: file.url,
          target: "_blank",
          style: {
            "--el-font-weight-primary": "bold"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(file.name), 1)]),
          _: 2
        }, 1032, ["href"])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("span", null, _toDisplayString(_unref(GetFileType)(file.ext)), 1), _createElementVNode("span", null, _toDisplayString(_unref(FormatFileSize)(file.size)), 1)])])]))]);
      }), 256))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
        class: "content",
        innerHTML: content.value
      }, null, 8, _hoisted_30)]), __props.data.created_at > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("span", _hoisted_32, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Clock))]),
        _: 1
      }), _createTextVNode(" " + _toDisplayString(_unref(dateFormat)(__props.data.created_at)), 1)])])) : _createCommentVNode("", true)])])]));
    };
  }
};